module.exports = __webpack_public_path__ + "img/logo-shiba888.e969ca30.png";